import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'outline';
  className?: string;
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  variant = 'primary',
  className = '',
  href,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3 text-base font-medium transition-colors duration-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#1e5631]';
  const variants = {
    primary: 'bg-[#1e5631] text-white hover:bg-[#164024] shadow-sm',
    outline: 'border-2 border-[#1e5631] text-[#1e5631] hover:bg-[#1e5631] hover:text-white'
  };
  const combinedClassName = `${baseStyles} ${variants[variant]} ${className}`;
  if (href) {
    return <a href={href} className={combinedClassName} {...props as React.AnchorHTMLAttributes<HTMLAnchorElement>} data-id="element-112">
        {children}
      </a>;
  }
  return <button className={combinedClassName} {...props} data-id="element-113">
      {children}
    </button>;
}